import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import isEqual_1 from '../../node_modules/lodash/isEqual.js';
import React__default from 'react';
import styled from 'styled-components';
import '../media/Img.js';
import { Icon } from '../media/Icon.js';
import { Box } from '../layout/Box.js';
import '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import { Scrollbars } from '../layout/Scrollbars.js';
import { Paragraph } from '../typography/Paragraph.js';
import { c as components } from '../../node_modules/react-select/dist/index-4bd03571.esm.js';
var formatOptionLabel = function formatOptionLabel(option, labelMeta) {
  var label = option.label,
    subtitle = option.subtitle;
  return labelMeta.context === "menu" ? React__default.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%"
  }, React__default.createElement(Box, null, React__default.createElement(Paragraph, {
    size: "md",
    color: "textPrimary",
    fontFamily: "matter"
  }, label), subtitle && React__default.createElement(Paragraph, {
    size: "sm",
    color: "grey.1",
    fontFamily: "matter"
  }, subtitle)), labelMeta.selectValue.find(function (x) {
    return isEqual_1(x, option);
  }) && React__default.createElement(Icon, {
    icon: "done",
    color: "green.300",
    fontSize: "24px"
  })) : label;
};
var DropdownIconWrapper = styled(Box)(function (_a) {
  var isMenuOpen = _a.isMenuOpen;
  return css({
    transform: isMenuOpen ? "rotate(180deg)" : "",
    transition: "all .3s ease",
    color: isMenuOpen ? "textPrimary" : "grey.1"
  });
});
var DropdownIndicator = function DropdownIndicator(props) {
  var menuIsOpen = props.selectProps.menuIsOpen;
  return React__default.createElement(components.DropdownIndicator, __assign({}, props), React__default.createElement(DropdownIconWrapper, {
    isMenuOpen: menuIsOpen
  }, React__default.createElement(Icon, {
    icon: "chevron_down",
    fontSize: "22px"
  })));
};
var VerticalTrack = styled.div(css({
  right: "6px !important",
  width: "4px !important",
  bottom: 16,
  top: 16
}));
var MenuList = function MenuList(_a) {
  var maxHeight = _a.maxHeight,
    children = _a.children;
  return React__default.createElement(Scrollbars, {
    autoHeight: true,
    autoHide: true,
    autoHeightMax: maxHeight,
    renderTrackVertical: function renderTrackVertical(trackProps) {
      return React__default.createElement(VerticalTrack, __assign({}, trackProps));
    }
  }, children);
};
var selectStyle = function selectStyle(_a) {
  var backgroundColor = _a.backgroundColor,
    _b = _a.isSearchable,
    isSearchable = _b === void 0 ? true : _b;
  return css({
    ".react-select__control": {
      border: "0",
      appearance: "none",
      outline: "none",
      fontSize: "16px",
      fontFamily: "matter",
      color: "textPrimary",
      width: "100%",
      backgroundColor: "unset",
      height: "60px"
    },
    ".react-select__control--is-focused": {
      boxShadow: "none"
    },
    ".react-select__value-container": {
      bottom: "8px",
      paddingTop: "32px",
      paddingX: "16px",
      width: "100%",
      input: {
        margin: !isSearchable ? "2px" : "initial",
        paddingY: !isSearchable ? "2px" : "initial"
      }
    },
    ".react-select__single-value": {
      position: "initial",
      transform: "none",
      lineHeight: "22px",
      marginX: "0",
      color: "textPrimary"
    },
    ".react-select__indicators": {
      height: "60px"
    },
    ".react-select__indicator-separator, .react-select__loading-indicator, .react-select__clear-indicator": {
      display: "none"
    },
    ".react-select__dropdown-indicator": {
      paddingRight: "14px",
      color: "grey.1",
      display: "initial"
    },
    ".react-select__menu": {
      borderRadius: "16px",
      border: "base",
      borderColor: "grey.5",
      boxShadow: "none",
      overflow: "hidden",
      backgroundColor: backgroundColor || "base",
      zIndex: "dropdown"
    },
    ".react-select__option": {
      height: "60px",
      paddingX: "16px",
      display: "flex",
      alignItems: "center",
      ":hover": {
        backgroundColor: "grey.4"
      },
      ":first-child": {
        marginTop: "8px"
      },
      ":first-child:nth-last-child(1)": {
        marginY: "0"
      },
      ":last-child": {
        marginBottom: "8px"
      }
    },
    ".react-select__option--is-focused": {
      backgroundColor: "grey.4"
    },
    ".react-select__option--is-selected": {
      backgroundColor: "grey.8"
    },
    ".react-select__menu-notice": {
      fontSize: "paragraph.md",
      fontFamily: "matter",
      fontWeight: "500",
      color: "grey.2",
      padding: "5px",
      marginY: "12px"
    }
  });
};
export { DropdownIndicator, MenuList, formatOptionLabel, selectStyle };